import React, { useContext, useEffect, useRef, useState } from "react";
import { ApiDataAccess } from "../../common/ApiDataAccess";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Confirmation } from "../../../core/Confirmation";
import { Alert } from "../../../core/Alert";
import { Popup } from "../../../core/Popup";
import { Cache } from "../../common/Cache";
import { SettingsContext } from "../../../infrastructure/SettingsContext";
import { LatestArticleRow } from "./LatestArticleRow";
import useNotifications from "../../../core/Notifications";
import { useLoader } from "../../../core/Loader";

export const LatestArticles = () => {
    const { settings } = useContext(SettingsContext);
    const dataAccess = new ApiDataAccess("/api/articles");
    const [items, setItems] = useState([]);
    const navigate = useNavigate();
    const confirmationRef = useRef(null);
    const [publishItem, setPublishItem] = useState(null);
    const cache = new Cache("latest-articles", 1);

    const [searchParams, setSearchParams] = useSearchParams();
    const notifications = useNotifications();
    const loader = useLoader();

    const term = searchParams.get("term");
    // componentDidMount() {
    //     this.LoadList();
    // }

    useEffect(() => {
        LoadData();
    }, []);

    const LoadData = () => {
        // var self = this;
        console.log("load the data", term);
        loader.start();
        if (term) {
            var request = {
                searchTerm: term,
                pageSize: 10000,
                pageIndex: 0,
            };

            dataAccess.post(
                "/search",
                request,
                (data) => {
                    setItems(data.items ? data.items : []);

                    console.log(data.items);
                    loader.stop();
                },

                (error) => {
                    console.log(error);
                    notifications.error({
                        message: "Could not load data for search.",
                    });
                    loader.stop();
                }
            );
        } else {
            cache
                .getOrAdd("all", function (key) {
                    return new Promise(function (resolve, reject) {
                        var url = "/latest";
                        dataAccess.get(
                            url,
                            (data) => {
                                resolve(data);
                            },
                            (error) => {
                                //Alerts.showError("Something went wrong. Please try again.");
                                reject(error);
                            }
                        );
                    });
                })
                .then((data) => {
                    // self.setState({
                    //     items: data ? data : new Array(),
                    // });
                    setItems(data ? data : []);
                    loader.stop();
                });
        }
    };

    const onClick = (item) => {
        //Router.setRoute("/articles/" + item.id);
        navigate(`/articles/${item.id}`);
    };

    const onClickPublish = (item) => {
        // var self = this;
        console.log(item);
        var id = item.id;
        var url = "/" + id + "/publish";

        return new Promise(function (resolve) {
            Confirmation.show(
                "Publish Article",
                " Are you sure that you want to publish this article to a different environment?",
                () => {
                    resolve(true);
                }
            );
        });
    };

    return (
        <div>
            {term && (
                <div>
                    <h1>Search Results</h1>
                    {items.length === 0
                        ? `I could not find any articles related to ${decodeURIComponent(term)}. You could try to change the search term and try again.`
                        : ""}
                </div>
            )}
            {items.length > 0 && (
                <div className="search-results">
                    {publishItem && (
                        <Confirmation
                            ref={confirmationRef}
                            onSaveClick={() => {
                                var id = publishItem.id;
                                var url = "/" + id + "/publish";
                                dataAccess.post(
                                    url,
                                    publishItem,
                                    (data) => {
                                        console.log(data);
                                        notifications.success({
                                            message: "Article published successfully.",
                                        });
                                    },

                                    (error) => {
                                        //Alerts.showError("Something went wrong. Please try again.");
                                        notifications.error({
                                            message: "Failed to publish the article.",
                                        });
                                    }
                                );
                            }}
                            onCancelClick={() => {}}
                        >
                            <div>Are you sure that you want to publish this article to a different environment?</div>
                        </Confirmation>
                    )}
                    {items.map((item, index) => {
                        return (
                            <LatestArticleRow
                                key={`row-${index}`}
                                item={item}
                                setPublishItem={setPublishItem}
                                onClick={onClick}
                                config={settings}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
    // }
};
